export default __webpack_public_path__ + "static/media/popup.86a5701d.png";